/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import BaseOptimization from './base-optimization';
import FilterConstants from '../../filter-constants';

export default class PowerOptimization extends BaseOptimization {
  name = FilterConstants.optimizationType.power;
  @computed('stopbandFrequency') get opAmpRequirementSpecValues() {
    var base = this;
    var stopbandFrequency = base.stopbandFrequency;
    var result = this.getOpAmpRequirementSpecValues(stopbandFrequency);
    return result;
  }

  //MD says: Does not appear to be used, so commenting out.
  /*     recreateStagesWithOptimization(stages){
        return stages;
    },  */
  determineCapacitorValue(stageFp) {
    var startingCapacitor = null;
    switch (true) {
      //fp is below 1.59Hz
      case stageFp < 1.59:
        //1/(2*PI*fp* 1 Mohm) in nF
        startingCapacitor = 1 / (2 * Math.PI * stageFp * 1000000);
        break;

      //fp is 1.59Hz to 15.9 Hz
      case stageFp >= 1.59 && stageFp <= 15.9:
        //100 nF
        startingCapacitor = 100 * 1e-9;
        break;

      //fp is 15.9Hz to 1.59kHz
      case stageFp >= 15.9 && stageFp <= 1590:
        //1/(2*PI*fp* 100kohm) in nF
        startingCapacitor = 1 / (2 * Math.PI * stageFp * 100000);
        break;

      //fp is 1.59kHz to 15.9 kHz
      case stageFp >= 1590 && stageFp <= 15900:
        //	1 nF
        startingCapacitor = 1 * 1e-9;
        break;

      //fp is above 15.9 kHz
      case stageFp > 15900:
        //1/(2*PI*fp*10 kohm) in nF
        startingCapacitor = 1 / (2 * Math.PI * stageFp * 10000);
        break;
    }

    return startingCapacitor;
  }

  determineStartingR3R4Value(stageFp) {
    var base = this; // to specify which one comes from the base class;
    var rMin = 1000;
    var rMax = 1000000;
    var result = base.processR3R4Value(stageFp, rMin, rMax);
    return result;
  }

  getOpAmpRequirementSpecValues(stopbandFrequency) {
    var base = this; // to specify which one comes from the base class;
    var specs = {
      fMultiplier: 50, //bigger is more strict:  used for highpass
      allowedError: 0.05, //smaller is more strict: used lowpass and bandpass
      rOutFreqMultiplier: 3, //rout shouldn't come into play until 5x stopband
      inductorMultiplier: 5,
      dcOutputVoltageFromIBias: 0.2,
      stopbandFrequency: stopbandFrequency,
    };

    specs.f = stopbandFrequency * specs.rOutFreqMultiplier;

    var result = base.adjustOpAmpRequirementSpecs(specs, stopbandFrequency);

    return result;
  }
}
